'use client';

import { useModal } from '@/components/ModalContext';
import rte, { rteHasContent } from '@/utils/rte';

const ScrollingValuePropsClient = ({ items, modal_content, heading }) => {
  const { openModal } = useModal();
  const hasModal = rteHasContent(modal_content);
  const sectionLabel = heading || 'Value propositions';

  const handleClick = () => {
    openModal(
      <div className="rte-content rte-content--light px-6 py-16 lg:p-24 font-worksans text-primary">
        <div dangerouslySetInnerHTML={{ __html: rte(modal_content) }} />
      </div>,
      'md:max-w-4xl xl:max-w-6xl',
      'bg-warm-white',
      { ariaLabel: sectionLabel },
      'max-h-[94vh] md:max-h-[90vh] xl:max-h-[82vh]',
    );
  };

  return (
    <section
      className="group relative mt-10"
      aria-label={hasModal ? undefined : sectionLabel}
    >
      <div className="overflow-hidden">
        <ul className="flex w-max animate-marquee group-hover:[animation-play-state:paused] group-focus-within:[animation-play-state:paused] motion-reduce:animate-none">
          {[...items, ...items].map((item, index) => (
            <li
              key={`${item._metadata?.uid || 'item'}-${index}`}
              aria-hidden={index >= items.length}
              className="flex-none px-8 font-worksans"
            >
              {item.heading && <p className="text-lg font-semibold">{item.heading}</p>}
              {item.content && <p className="mt-1 text-base">{item.content}</p>}
            </li>
          ))}
        </ul>
      </div>

      {hasModal && (
        <button
          type="button"
          onClick={handleClick}
          aria-haspopup="dialog"
          aria-label={sectionLabel}
          className="absolute inset-0 z-10 cursor-pointer border-0 bg-transparent p-0 focus-visible:bg-sea/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-sea"
        />
      )}
    </section>
  );
};

export default ScrollingValuePropsClient;
